import { authApiClient } from '@/core/infra_api_client'
import type {
  OIDCClient,
  CreateOIDCClientRequest,
  UpdateOIDCClientRequest,
} from '@/core/infra_types'

const BASE = 'oidc-clients'

export async function listOIDCClients(): Promise<OIDCClient[]> {
  return authApiClient.get<OIDCClient[]>(BASE)
}

export async function getOIDCClient(clientId: string): Promise<OIDCClient> {
  return authApiClient.get<OIDCClient>(`${BASE}/${encodeURIComponent(clientId)}`)
}

export async function createOIDCClient(req: CreateOIDCClientRequest): Promise<OIDCClient> {
  return authApiClient.post<OIDCClient, CreateOIDCClientRequest>(BASE, req)
}

export async function updateOIDCClient(clientId: string, req: UpdateOIDCClientRequest): Promise<OIDCClient> {
  return authApiClient.put<OIDCClient, UpdateOIDCClientRequest>(
    `${BASE}/${encodeURIComponent(clientId)}`,
    req,
  )
}

export async function deleteOIDCClient(clientId: string): Promise<void> {
  await authApiClient.delete(`${BASE}/${encodeURIComponent(clientId)}`)
}
